import { KNOWN_ERROR } from "./errors";

export const STORE_ORDER_STATUS = [
    // default status for all orders
    "DRAFT", // means payment is not verified

    "EXPIRED", // draft orders that are not paid/placed after 1 hour

    // order is scheduled to be placed at a specific time
    // it will be "SCHEDULED" after payment is verified
    "SCHEDULED", // once the time is reached, it will be "PLACED"

    // online orders will become "PLACED" after payment is authorized
    // if it is not online it will be "PLACED"
    "PLACED",

    // Order is accepted by store and being prepared
    // system may accept the order immediately or by print automation
    "ACCEPTED",

    // Order was cancelled by store or system
    // if it is not accepted in 25 minutes, it will be "CANCELLED" by system
    // buyers are not allow to cancel. but may call/contact the store to cancel
    "CANCELLED",

    // once order is completed, no status change will be applied.
    // only system can complete an order
    // cancelled orders also will be "COMPLETED"
    "COMPLETED",
] as const;

export type StoreOrderStatus = (typeof STORE_ORDER_STATUS)[number];
export const STORE_ORDER_STATUS_OBJ = STORE_ORDER_STATUS.reduce((acc, status) => {
    acc[status] = status;
    return acc;
}, {} as Record<StoreOrderStatus, StoreOrderStatus>);


const allowedTransitions: Record<StoreOrderStatus, StoreOrderStatus[]> = {
    DRAFT: ['SCHEDULED', 'PLACED', 'EXPIRED'],
    EXPIRED: [],

    SCHEDULED: ['PLACED', 'CANCELLED'],
    PLACED: ['ACCEPTED', 'CANCELLED'],
    ACCEPTED: ['CANCELLED', 'COMPLETED'],
    CANCELLED: ['COMPLETED'],
    COMPLETED: [],
};

export const isStoreOrderAllowedToCancel = (orderStatus: StoreOrderStatus) => {
    return orderStatus === STORE_ORDER_STATUS_OBJ.PLACED || orderStatus === STORE_ORDER_STATUS_OBJ.ACCEPTED || orderStatus === STORE_ORDER_STATUS_OBJ.SCHEDULED;
}

export const isStoreOrderAllowedToAccept = (orderStatus: StoreOrderStatus) => {
    return orderStatus === STORE_ORDER_STATUS_OBJ.PLACED;
}

export function isStoreOrderAllowedStatusChange(from: StoreOrderStatus, to: StoreOrderStatus) {
    if (allowedTransitions[from].includes(to)) {
        return true;
    } else {
        console.error(`Order status not allowed to be changed from ${from} to ${to}`);
        throw new KNOWN_ERROR(
            `Order status not allowed to be changed from ${from} to ${to}`,
            "STORE_ORDER_STATUS_NOT_ALLOWED_TO_BE_CHANGED"
        );
        // return false;
    }
}


/*/
THESE INFO MAY BE OUTDATED, CHECK WITH THE CODE

Once an order placed, it will be "DRAFT" by default
Only online paid orders's keep status as "DRAFT"
(Restaurant/staff handled payment types like cash will become "PLACED" immediately)

once payment confirmed order order_placed_at_ts will be updated
and order status will be "PLACED"
if online payment can not be verified, in 10 minutes it will send email notification to user.
after 1 hour payment link will be expired.
after 24 hours later it will be cancelled(and marked as expired) by system in CompleteOrder cron.
next CompleteOrder cron will mark it as "COMPLETED"


Every 5 minutes created orders checked, if not accepted, it will be "CANCELLED" after 25 minutes.
also store will be notified for waiting orders that not accepted in every 5 minutes until to accept or cancel(after 25 minutes).
(orders are need to be accepted by store in 25 minutes.)

(print automations can accept the order once it is printerd
(and autoAccept setting can also accept the "PLACED" orders immediately)
(online payment or not(cash, card, etc.) orders will be accepted immediately)

Accepted orders will be "COMPLETED" after 24 hours.
Online payment orders will capture the payment in CompleteOrder cron.

Canceled orders will be "COMPLETED" after 24 hours.
But it will cancel payments or refund or expire the payment link

if order print task not completed in 10 minutes, it will be removed from queue.
and store will be notified for it.
/*/

// store orders view is showing only last 24 hours orders (order.service -> getRecentOrders_Service)


/*/
== Status types from Stripe ==

type PaymentIntentStatus =
        | 'canceled'
        | 'processing'
        | 'requires_action'
        | 'requires_capture'
        | 'requires_confirmation'
        | 'requires_payment_method'
        | 'succeeded';

type CheckoutSessionStatus = 'complete' | 'expired' | 'open';

type CheckoutSessionPaymentStatus = 'no_payment_required' | 'paid' | 'unpaid'; 
// I use manual capture so CheckoutSessionPaymentStatus is "unpaid" after checkout session status is "complete"

/*/
